import React, { useState, useEffect } from "react";
import axios from 'axios';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import Pagination from "react-js-pagination";
import pagiarray from 'paginate-array';
import SelectCenter from "../util/SelectCenter";
import Filter from '../util/Filter';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { format } from 'date-fns';
import { confirmAlert } from 'react-confirm-alert';
import GetApiHost from '../util/GetApiHost';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Tag, Space } from "antd";

const { Column, ColumnGroup } = Table;

const data = [
  {
    key: "1",
    firstName: "John",
    lastName: "Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
  {
    key: "2",
    firstName: "Jim",
    lastName: "Green",
    age: 42,
    address: "London No. 1 Lake Park",
    tags: ["loser"],
  },
  {
    key: "3",
    firstName: "Joe",
    lastName: "Black",
    age: 32,
    address: "Sidney No. 1 Lake Park",
    tags: ["cool", "teacher"],
  },
];

var activePage = 1;
var totalCount = 0; //총회원수
const pageSize = 10;
var teacherData = '';
var clear = false;
var name = '';
var phone = '';
var filterMode = {
    name : true,
    phone : true
}

let storage = {
    nameKeyword : '',
    phoneKeyword : '',
    teacherCount : 0
}

export default function Teacher() {
    const [teacher, setTeacher] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [selectedCenter, setSelectedCenter ] = useState('');
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handleClear(){
        storage.nameKeyword = '';
        storage.phoneKeyword = '';
        clear = true;
        activePage = 1;
        getTeacher();
    }

    function handleFilter(filterData){
        storage.nameKeyword = filterData.nameKeyword;
        storage.phoneKeyword = filterData.phoneKeyword
        activePage = 1;
        getTeacher();
    }

    function handlePageChange(changepage) {
        activePage = changepage;
        const page = activePage;
        const pageCurrent = pagiarray(teacherData,page,pageSize);

        totalCount = teacherData.length;

        setTeacher(pageCurrent.data);
    }

    function getTeacher(){
        if(clear === true){
            name = ''
            phone = '';
        }else{
            name = storage.nameKeyword;
            phone = storage.phoneKeyword;
        }
        var temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        axios({
            url : data.url + "/slim/teacher",
            method : "post",
            data : {
                sid : 'smartgym',
                cid : temp_cid,
                nameKeyword : name,
                phoneKeyword : phone
            }
        }).then(function (res){
            teacherData = res.data;
            const page = activePage;
            const pageCurrent = pagiarray(teacherData,page,pageSize);

            totalCount = teacherData.length;

            setTeacher(pageCurrent.data)
            clear = false;
        }).catch(function(error){
            console.log(error);
        })
    }

    function getTeacherCount(){
        var temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        axios({
            url : data.url + "/slim/teacher_count",
            method : "post",
            data : {
                sid : 'smartgym',
                cid : temp_cid,
            }
        }).then(function (res){
            storage.teacherCount = res.data[0].count;
        }).catch(function(error){
            console.log(error);
        })
    }

    function handleClick(tcd){
        window.location.href = '/teacherInfo/'+tcd;
    }

    function resetDevice(tcd, name){
        confirmAlert({
            title: '기기 초기화 확인',
            message: name + "님의 기기 정보를 초기화하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => handleReset(tcd)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    function handleReset(tcd){
        (async function () {
            const api_host = GetApiHost();
            const result = await axios.post(api_host + '/admin/reset_device', {
                mcd : tcd
            })
            if(result.data.ret == 'Y'){
                alert('초기화 되었습니다');
            }else{
                alert(result.data.msg)
            }
        })();

    }


    function handleAdd(){
        window.location.href = '/teacherInfoAdd'
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            console.log(decodeResult);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getTeacherCount();
            getTeacher();
            activePage = 1;
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getTeacherCount();
            getTeacher();
            activePage = 1;
        }
    },[selectedCenter]);

    return (
      <main className="main-container">
        <TopNav />
        <div className="content-wrapper">
          <MainNav />

          <div className="content-inner">
            <h3>강사 관리</h3>
            <span>총 강사 수 : 33333</span>

            <div className="content-component">
              <div className="content-header">
                {/* <Button className="add-button"> &nbsp; 강사 추가 </Button> */}
                <SelectCenter onSelectedCenter={handleSelectedCenter} />
              </div>

              <div className="content-body">
                <div className="table-header">
                  <div></div>
                  <div style={{ display: "inline-flex" }}>
                    <Filter
                      handleFilter={handleFilter}
                      handleClear={handleClear}
                      mode={filterMode}
                    />
                  </div>
                </div>
                <div className="table-body cursor">
                  <Table dataSource={data}>
                    <ColumnGroup title="Name">
                      <Column
                        title="First Name"
                        dataIndex="firstName"
                        key="firstName"
                      />
                      <Column
                        title="Last Name"
                        dataIndex="lastName"
                        key="lastName"
                      />
                    </ColumnGroup>
                    <Column title="Age" dataIndex="age" key="age" />
                    <Column title="Address" dataIndex="address" key="address" />
                    <Column
                      title="Tags"
                      dataIndex="tags"
                      key="tags"
                      render={(tags) => (
                        <>
                          {tags.map((tag) => (
                            <Tag color="blue" key={tag}>
                              {tag}
                            </Tag>
                          ))}
                        </>
                      )}
                    />
                    <Column
                      title="Action"
                      key="action"
                      render={(text, record) => (
                        <Space size="middle">
                          <a>Invite {record.lastName}</a>
                          <a>Delete</a>
                        </Space>
                      )}
                    />
                  </Table>
                  {/* <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th style={{width:'120px'}}>이름</th>
                                <th style={{width:'350px'}}>연락처</th>
                                <th style={{width:'350px'}}>가맹점</th>
                                <th style={{width:'70px'}}>기기</th>
                                <th style={{width:'290px'}}>등록일</th>
                            </tr>
                        </thead>
                        <tbody>
                        {(totalCount === 0 && loaded === 1 ) &&
                                <tr>
                                    <td colSpan='20'>
                                        데이터가 없습니다.
                                    </td>
                                </tr>
                        }
                        {teacher.map(( teacher, index ) => {
                            const { tcd, name, phone, center, location, regdate } = teacher;
                            var formatRegdate = regdate.substring(0,16);

                            return(
                                <tr key={index} >
                                    <td onClick={() => handleClick(tcd)}>{name}</td>
                                    <td onClick={() => handleClick(tcd)}>{phone}</td>
                                    <td onClick={() => handleClick(tcd)}>{center + " " +location}</td>
                                    <td><Button onClick={() => resetDevice(tcd, name)} size="sm" style={{fontSize : 10}}>초기화</Button></td>
                                    <td onClick={() => handleClick(tcd)} className="td-regdate">{formatRegdate}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </Table> */}
                </div>
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={pageSize}
                  pageRangeDisplayed={5}
                  totalItemsCount={totalCount}
                  itemClass="page-item"
                  linkClass="page-link"
                  onChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    );
}